<dx-data-grid
  id="transportInterventionsGridContainer"
  [ngStyle]="gridCss"
  [dataSource]="ds"
  [showRowLines]="true"
  [remoteOperations]="{ paging: true, sorting: true, filtering: true}"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="true"
  [columnHidingEnabled]="false"
  [columnAutoWidth]="true"
  [errorRowEnabled]="false"
  (onRowDblClick)="showInterventionDetails($event)"
  (onExporting)="onExporting($event)"
  [libGridTitle]="{text: 'Interventions du Transport'}"
  [showBorders]="false">

  <dxi-column
    caption="ID"
    dataField="id"
    [allowEditing]="false"
    [formItem]="{visible: false}"
    dataType="number">
  </dxi-column>

  <dxi-column cellTemplate="reportIconTemplate"
              [allowExporting]="false"
              [allowHeaderFiltering]="false"
              [allowSorting]="false"
              [allowSearch]="false"
    [allowEditing]="false"
    [formItem]="{visible: false}"
              [width]="40"
    dataType="number">
        <span *dxTemplate="let cell of 'reportIconTemplate'">
          <a title="Rapport" href="#" (click)="showInterventionDetails(cell, $event)">
          <ic-icon [icon]="reportIcon" width="18px" height="18px" [inline]="true"></ic-icon>
          </a></span>
  </dxi-column>

  <dxi-column caption="Date et Heures">
    <dxi-column
      caption="Date"
      dataField="start_time"
      sortOrder="desc"
      format="shortDate"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Début"
      dataField="start_time"
      format="shortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Fin"
      dataField="stop_time"
      format="shortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Durée"
      dataField="duration_human">
    </dxi-column>
  </dxi-column>

  <dxi-column caption="Véhicule">
    <dxi-column caption="Nom" dataField="vehicle.name"></dxi-column>
    <dxi-column caption="Outil" cellTemplate="tagTemplate" dataField="tag_details.taggable.taggable_name"></dxi-column>
    <dxi-column *ngFor="let tagAttrName of attributesNames"
                dataType="string"
                [filterOperations]="[]"
                [caption]="tagAttrName"
                [dataField]="'attributes.'+tagAttrName"
                cellTemplate="tagAttrTemplate">

      <dxo-header-filter
        [dataSource]="attributesValues[tagAttrName]">
      </dxo-header-filter>
    </dxi-column>
  </dxi-column>

  <div *dxTemplate="let cell of 'tagTemplate'">
    <div class="w-full flex items-center justify-start">
      <div *ngIf="cell.value" class="px-1">{{cell.value}} - </div>
      <a href="#" (mouseenter)="showTags($event, cell.data)">
        <ic-icon [icon]="tagsIcon" width="18px" height="18px" [inline]="true"></ic-icon>
      </a>
    </div>
  </div>

  <div *dxTemplate="let cell of 'tagAttrTemplate'">{{ getTagAttrValue(cell) }}</div>

  <dxi-column caption="Adresses">
    <dxi-column caption="Distance" format="#0.##" dataField="metrics.length_in_km"></dxi-column>
    <dxi-column caption="Adresse 1" dataField="endpoints.first_poi_name"></dxi-column>
    <dxi-column caption="Arrêt" dataField="endpoints.first_poi_visits_duration" cellTemplate="tmp">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
    </dxi-column>
    <dxi-column caption="Adresse 2" dataField="endpoints.second_poi_name"></dxi-column>
    <dxi-column caption="Arrêt" dataField="endpoints.second_poi_visits_duration" cellTemplate="tmp">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span></dxi-column>
    <dxi-column dataType="number" caption="Allers-retours" format="#0.##" dataField="endpoints.roundTrips"></dxi-column>
    <dxi-column caption="Vitesse Moyenne" format="#0.##" dataField="metrics.speed_avg"></dxi-column>
    <dxi-column caption="Vitesse Maximale" format="#0.##" dataField="metrics.speed_max"></dxi-column>
  </dxi-column>

  <dxi-column caption="Consomation Carburant">
    <dxi-column caption="Totale (L)" format="#0.##" dataField="metrics.fuel_total_consumption"></dxi-column>
    <dxi-column caption="Litres / h" format="#0.##" dataField="metrics.fuel_hourly_consumption_rate_avg"></dxi-column>
    <dxi-column caption="Heures Moteurs" format="#0.##" dataField="metrics.engine_working_hours"></dxi-column>
    <dxi-column caption="Temperature" format="#0.##" dataField="metrics.fuel_temperature_avg"></dxi-column>
  </dxi-column>

  <dxi-column caption="Domaine">
    <dxi-column caption="Nom" dataField="domain_name"></dxi-column>
    <dxi-column caption="BU" dataField="business_unit_name"></dxi-column>
  </dxi-column>

  <dxo-selection
    selectAllMode="page"
    mode="multiple"
  ></dxo-selection>

  <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

  <dxo-group-panel [visible]="false"></dxo-group-panel>

  <dxo-export [enabled]="true" fileName="liste-interventions-transport"
              [allowExportSelectedData]="true"></dxo-export>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-paging [pageSize]="25"></dxo-paging>

  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[25, 50, 100]"
    [showInfo]="true">
  </dxo-pager>

  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxo-search-panel
    [visible]="true"
    [width]="240"></dxo-search-panel>

  <dxo-header-filter [visible]="true"></dxo-header-filter>

</dx-data-grid>

<dx-popover
  [target]="tagDetailsEl"
  position="top"
  title="Information de la carte"
  [showTitle]="true"
  hideEvent="mouseleave"
  [width]="300"
  [(visible)]="tagDetailsVisible">
  <div *dxTemplate="let data = model of 'content'">
    <div class="details-list">
      <div>Catégorie</div>
      <div>{{current.tag_details.category.name}}</div>
      <ng-container *ngFor="let attr of current.tag_details.attributes">
        <div>{{attr.name}}</div>
        <div>{{attr.value}}</div>
      </ng-container>
    </div>
  </div>
</dx-popover>

<app-transport-interventions-report
  *ngIf="current"
  [(visible)]="reportVisible"
  [intervention]="current"
  [request]="request">
</app-transport-interventions-report>
